/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { get } from "lodash";
import TextField from "components/text-field/text-field";
import { FastlyConfig, Integrations } from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

interface Props {
  integration: { key: Integrations.Fastly; value: FastlyConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const Fastly: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.access-key")}
        value={integration.value["access-key"]}
        onChange={(value) => updateIntegrationField(integrationName, { "access-key": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<FastlyConfig>(errors)
            ? get(errors, ["errors", "value", "access-key", "0"])
            : undefined
        }
      />
      <TextField
        label={t("integrations.fields.service-id")}
        value={integration.value["service-id"]}
        onChange={(value) => updateIntegrationField(integrationName, { "service-id": value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<FastlyConfig>(errors)
            ? get(errors, ["errors", "value", "service-id", "0"])
            : undefined
        }
      />
    </React.Fragment>
  );
};

export default Fastly;
